const handleDeleteDocumentFileModalAction = {
  confirm: 'Deseja realmente deletar esse arquivo?',
  title: 'DELETAR ARQUIVO'
};

export default handleDeleteDocumentFileModalAction;
